import _ from 'lodash'
import {useGetAllShipmentsWithPickupAndDeliveryDataQuery} from '../../redux/commonRTK'
import RevenueSummary from './RevenueSummary'
import StatusTree from './StatusTree'
import {
  getOrderStatus, rto as rtoStatus, cancelled as cancelledStatus, lost, getYYYYMMDD, filterShipmentsByFlow,
} from '../../helpers/UtilityHelper'
import ShipingCostRevenue from './ShipingCostRevenue'
import Loader from '../../common/Loader'
import Performance from './Performance'
import {getMerchant} from '../../helpers/ReduxHelpers'

export default function ShippingOverview({dateRange, shipType, flow = 'ALL'}) {
  const {fromDate: from_date, toDate: to_date} = {fromDate: dateRange[0].startDate, toDate: dateRange[0].endDate}
  const requestPayload = {from_date: getYYYYMMDD(from_date), to_date: getYYYYMMDD(to_date), merchant_list: getMerchant()?.id, shipmentType_list: shipType}
  const skip = !from_date || !to_date
  const {data, isLoading, isFetching} = useGetAllShipmentsWithPickupAndDeliveryDataQuery(requestPayload, {skip})
  // Scope to the active flow (Forward / Reverse) before computing any metric.
  const allRegistedShipments = filterShipmentsByFlow(data || [], flow).map((i) => ({...i, price: Number(i.price) || 0}))

  if (isLoading || isFetching) return <Loader />

  const scatterData = {count: allRegistedShipments?.length || 0, data: allRegistedShipments}

  return (
    <>
      <OrdersOrgChart data={scatterData} flow={flow} />
      <ShipingCostRevenue data={scatterData} from_date={from_date} to_date={to_date} flow={flow} />
      <Performance data={scatterData} />
    </>
  )
}

function OrdersOrgChart({data: {data = []}, flow = 'ALL'}) {
  let newObject = []
  const total = {title: 'Total Shipments', id: 1, count: data.length || 0}
  const placed = {title: 'Shipments Placed', id: 2, parentId: 1, count: 0}
  const inTransit = {title: 'In-Transit', id: 3, parentId: 1, count: 0}
  const delivered = {title: 'Delivered', id: 4, parentId: 1, count: 0}
  const rto = {title: 'RTO', id: 5, parentId: 1, count: 0}
  // Lost gets its own status node (previously it was merged into RTO).
  const lostNode = {title: 'Lost', id: 6, parentId: 1, count: 0}
  // Delivery Failed (NDR) is its OWN node — not folded into In-Transit — so the tree's
  // In-Transit matches the Donut and the Hero KPI (all three = INTRANSIT only).
  const deliveryFailed = {title: 'Delivery Failed', id: 7, parentId: 1, count: 0}
  let lastId = 8
  const groupedData = _.groupBy(data, 'orderStatus')
  let rtoOrdersCost = 0
  for (const k in groupedData) {
    if (k === 'undefined' || k === 'UNPROCESSED' || k === 'NA') continue
    const orderStatus = getOrderStatus(k)
    let parentId
    if (orderStatus === 'ORDER_PLACED') { placed.count += groupedData[k].length; parentId = placed.id }
    else if (orderStatus === 'INTRANSIT') { inTransit.count += groupedData[k].length; parentId = inTransit.id }
    else if (orderStatus === 'DELIVERY_FAILED') { deliveryFailed.count += groupedData[k].length; parentId = deliveryFailed.id }
    else if (orderStatus === 'DELIVERED') { delivered.count += groupedData[k].length; parentId = delivered.id }
    else if (orderStatus === 'LOST') { lostNode.count += groupedData[k].length; parentId = lostNode.id }
    else if (orderStatus === 'RTO' || orderStatus === 'CANCELLED') {
      if (orderStatus === 'RTO') rtoOrdersCost += _.sumBy(groupedData[k], 'price') || 0
      rto.count += groupedData[k].length; parentId = rto.id
    }
    if (orderStatus !== 'DELIVERED') {
      newObject.push({id: lastId, parentId, count: groupedData[k].length, title: _.startCase(k)})
      lastId++
    }
  }
  const chartData = [...newObject, placed, delivered, rto, lostNode, deliveryFailed, inTransit, total]
  const revenueSummary = {
    totalRevenue: _(data).filter((val) => ![...rtoStatus, ...cancelledStatus, ...lost].includes(val.orderStatus)).sumBy('invoiceValue'),
    totalShipmentCost: Math.round(_(data).filter((val) => !cancelledStatus.includes(val.orderStatus)).sumBy('price')),
    totalShipments: data.length,
    totalRTOCost: rtoOrdersCost,
    totalLostShipmentsCost: _.sumBy(_.filter(data, {orderStatus: 'LOST'}), 'invoiceValue'),
  }
  return (
    <>
      <RevenueSummary data={revenueSummary} flow={flow} />
      <StatusTree nodes={chartData} />
    </>
  )
}

